import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SubCustomersTable = ({
  subcustomers,
  setIdSubCustomerEdit,
  setOpenModalSubcustomer
}) => {
  const columns = [
    {
      accessorKey: 'determinanate',
      header: 'Determinante',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'descripcion',
      header: 'SubCliente',
      headerProps: { style: { minWidth: '300px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idsubcliente',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idsubcliente } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdSubCustomerEdit(idsubcliente);
                setOpenModalSubcustomer(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      {subcustomers && (
        <GenericTable
          data={subcustomers}
          title="SubClientes"
          columns={columns}
          addAction={() => {
            setIdSubCustomerEdit(0);
            setOpenModalSubcustomer(true);
          }}
        ></GenericTable>
      )}
    </>
  );
};
SubCustomersTable.propTypes = {
  subcustomers: PropTypes.array.isRequired,
  setIdSubCustomerEdit: PropTypes.func.isRequired,
  setOpenModalSubcustomer: PropTypes.func.isRequired
};
export default SubCustomersTable;
